module.exports = __webpack_public_path__ + "img/exchange -rate.055b312a.svg";